/*
 * 本文件为 国际酒店路由
 */

const routeInHt = [
  {
    path: "inHtRouter",
    component: () =>
      import(
        /* webpackChunkName: "routeMain" */ "./../../views/international/interHt/InHt"
      ),
    redirect: "inHtRouter/intHtQuery",
    children: [
      {
        path: "intHtQuery",
        name: "intHtQuery",
        component: () =>
          import(
            /* webpackChunkName: "routeMain" */ "@/views/intHt/IntHtQuery"
          ),
        meta: {
          title: "国际酒店查询",
        },
      },
      {
        path: "inHtEdit",
        name: "InHtEdit",
        component: () =>
          import(
            /* webpackChunkName: "routeMain" */ "@/views/international/interHt/InHtEdit"
          ),
        meta: {
          title: "国际酒店需求单",
        },
      },
      {
        path: "interHotelDetail",
        name: "interHotelDetail",
        component: () =>
          import(
            /* webpackChunkName: "routeMain" */ "@/views/intHt/interHotelDetail"
          ),
        meta: {
          title: "国际酒店详情",
        },
      },
      {
        path: "intHtEdit",
        name: "intHtEdit",
        component: () => import("@/views/intHt/intHtEdit"),
        meta: {
          title: "国际酒店订单填写",
        },
      },
    ],
  },
];

export default routeInHt;
